export const DELAY_BEFORE_FORM_RESET = 5000

// Названия идентификаторов сущностей
export const FORM_ENTITY_NAME = {
  PROMOTION: 'promotion',
  EVENT: 'event',
  VENDOR: 'vendor',
  PRACTICE: 'practice',
  QUESTIONNAIRE: 'questionnaires',
  DECISION: 'decision',
  SERVICE: 'service',
  SUBSCRIBE: 'subscribe',
}

// Идентификаторы сущностей
export const FORM_ENTITY_ID = {
  EVENT: 1,
  PROMOTION: 2,
  VENDOR: 3,
  PRACTICE: 4,
  QUESTIONNAIRE: 5,
  DECISION: 6,
  SERVICE: 7,
  SUBSCRIBE: 8,
}

export const nameEntityToEntityEmailIdMap = nameEntity => {
  switch (nameEntity) {
    case FORM_ENTITY_NAME.EVENT:
      return FORM_ENTITY_ID.EVENT
    case FORM_ENTITY_NAME.PROMOTION:
      return FORM_ENTITY_ID.PROMOTION
    case FORM_ENTITY_NAME.VENDOR:
      return FORM_ENTITY_ID.VENDOR
    case FORM_ENTITY_NAME.PRACTICE:
      return FORM_ENTITY_ID.PRACTICE
    case FORM_ENTITY_NAME.QUESTIONNAIRE:
      return FORM_ENTITY_ID.QUESTIONNAIRE
    case FORM_ENTITY_NAME.DECISION:
      return FORM_ENTITY_ID.DECISION
    case FORM_ENTITY_NAME.SERVICE:
      return FORM_ENTITY_ID.SERVICE
    case FORM_ENTITY_NAME.SUBSCRIBE:
      return FORM_ENTITY_ID.SUBSCRIBE
    default:
      console.error(`Unknown nameEntity: ${nameEntity}`)
      return null
  }
}

export const FORM_VARIANTS = {
  DEFAULT: 'default',
  STEPS: 'steps',
}

export const LEGACY_FORM_VARIANTS = {
  DEFAULT_BOTTOM: 0, // Обычная. Внизу страницы
  STEPS_BOTTOM: 1, // С шагами. Внизу страницы
  DEFAULT_BUILDER: 2, // Обычная. В конструкторе
  STEPS_BUILDER: 3, // С шагами. В конструкторе
}

export const FORM_COLOR_IDX = {
  WHITE: 0,
  CYAN: 1,
}

export const FORM_THEME_MAP = {
  [FORM_COLOR_IDX.WHITE]: 'white',
  [FORM_COLOR_IDX.CYAN]: 'cyan',
}

export const FORM_DEFAULT_THEME = FORM_THEME_MAP[FORM_COLOR_IDX.CYAN]

export function resolveFormVariant(formConfig = {}) {
  if (formConfig.type === LEGACY_FORM_VARIANTS.DEFAULT_BOTTOM || formConfig.type === LEGACY_FORM_VARIANTS.DEFAULT_BUILDER) {
    return FORM_VARIANTS.DEFAULT
  }

  return FORM_VARIANTS.STEPS
}

export const FORM_LAYOUT = {
  DEFAULT: 'default',
  TEXT_ASIDE: 'text-aside',
}



// WEBPACK FOOTER //
// ./src/modules/shared/const/form/form.data.js